import { render, staticRenderFns } from "./licenseInfo.vue?vue&type=template&id=1b2ba09c&scoped=true&"
import script from "./licenseInfo.vue?vue&type=script&lang=js&"
export * from "./licenseInfo.vue?vue&type=script&lang=js&"
import style0 from "./licenseInfo.vue?vue&type=style&index=0&id=1b2ba09c&lang=less&scoped=true&"
import style1 from "./licenseInfo.vue?vue&type=style&index=1&id=1b2ba09c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2ba09c",
  null
  
)

export default component.exports